import Vue from "vue";
import Vuex from "vuex";
import { userModule } from "@/store/user";
import {getPublickey} from "../axios/user";
import {JSEncrypt} from "jsencrypt";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: userModule,
  },
  state: {
    jsEnc: null,
  },
  mutations: {
    setJsEnc(state, payload) {
      state.jsEnc = payload
    }
  },
  actions: {
    initJsEnc({commit}) {
      getPublickey().then(({ data }) => {
        const enc = new JSEncrypt()
        enc.setPublicKey(data.data)
        commit('setJsEnc', enc)
      })
    }
  }
});
